import { render } from "./PosApiTest.vue?vue&type=template&id=67adfeb6&scoped=true"
import script from "./PosApiTest.vue?vue&type=script&lang=js"
export * from "./PosApiTest.vue?vue&type=script&lang=js"

import "./PosApiTest.vue?vue&type=style&index=0&id=67adfeb6&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67adfeb6"]])

export default __exports__